import {
  resourceReducer,
} from 'redux-resource';
import {
  includedResources,
  selection,
} from 'redux-resource-plugins';

import {
  allListPlugin,
} from './plugins';

export default resourceReducer('clientGroups', {
  initialState: {
    ...selection.initialState,
  },
  plugins: [
    includedResources,
    allListPlugin,
    selection,
  ],
});
